module.exports = __webpack_public_path__ + "img/user1.47a6b5d5.png";